import styled, { createGlobalStyle } from 'styled-components';
import ProgressIndicator from '@veneer/core/dist/scripts/progress_indicator';
import { LARGE_SCREEN_WIDTH_REM } from '../../utils/constants';

import HPSimplifiedW01Regular from '../../fonts/HPSimplifiedW01-Regular.woff';
import HPSimplifiedW01Light from '../../fonts/HPSimplifiedW01-Light.woff';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-display: swap;
    font-family: 'HP Simplified';
    font-weight: normal;
    src: local('HP Simplified'),
    url(${HPSimplifiedW01Regular}) format("woff");
  }

  @font-face {
    font-display: swap;
    font-family: 'HP Simplified';
    font-weight: 300;
    src: local('HP Simplified'), url(${HPSimplifiedW01Light}) format("woff");
  }

  *:focus {
    outline: none;
  }

  html, body {
    padding: 0;   
    margin: 0;
    font-family: 'HP Simplified', arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  *:focus,
  *: -webkit-direct-focus{
    outline: none !important;
  }

`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
  ${({ theme: { fullScreen } }) =>
    fullScreen
      ? `
        height: 100vh;
        background-color: #f2f2f2;
        `
      : `
        height: auto;
      `}
  @media screen and (min-width: ${LARGE_SCREEN_WIDTH_REM}) {
    max-width: ${({ theme: { fullScreen } }) => (fullScreen ? 'auto' : '55.5rem')};
    margin: auto;
  }

  &&.closed {
    height: 0;
    overflow: hidden;
    transition: 0.5s;
  }
  
  &&.debug-mode {
    background-color: #d5d5d5;
  }
  > .hide {
    display: none;
  }

  > .show {
    display: block;
  }
`;

export const StyledProgressIndicator = styled(ProgressIndicator)`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    height: ${({ theme: { fullScreen } }) => (fullScreen ? '90vh' : '8rem')};
    > div {
      width: 2rem;
      height: 2rem;
    }
    @media screen and (min-width: ${LARGE_SCREEN_WIDTH_REM}) {
      height: ${({ theme: { fullScreen } }) => (fullScreen ? '90vh' : '8.5rem')};
    }
  }
`;
export const StyledProgressIndicatorSmall = styled(ProgressIndicator)`
  && {
    display: flex;
    align-items: center;
    padding-right: 0.25rem;

    > div {
      width: 1rem;
      height: 1rem;
    }
  }
`;
